import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {

        const { FormPermissions } = Forms
        const { setFormState } = FormPermissions
        // console.log('[useActions][handleClickDemoModal] dataRequest.data: ', dataRequest.data)
        setFormState(prevState => ({
            ...prevState,
            idpermiso: dataRequest.data.idpermiso || '',
            tag: dataRequest.data.tag || '',
            idpermiso_padre: dataRequest.data.idpermiso_padre || '',
            nombrepermisos: dataRequest.data.nombrepermisos || '',
            estado: parseInt(dataRequest.data.estado, 10) || ''
        }))

        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        // const { setShowForm } = globalStates
        // setShowForm(flag)
        toggle()
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        // const { FormPermissions } = Forms
        // const { onResetForm } = FormPermissions

        // onResetForm()
        // handleClickShowForm(false)
        toggle()

    }

    const handleClickFetchAllPermissions = async () => {

        const { fetchAllPermissions } = FetchData
        const { executeFetch } = fetchAllPermissions

        executeFetch()

    }

    const handleClickEnableData = async (idpermiso) => {

        const { FormPermissions, FormPermissionsChild } = Forms
        const { formState: formStateFather, onResetForm: onResetFormFather } = FormPermissions
        const { formState: formStateChild, onResetForm: onResetFormChild } = FormPermissionsChild

        Swal.fire({
            title: '¿Está seguro de Activar este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/permissions/enable-permission/${idpermiso}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetFormFather()
                    onResetFormChild()
                    handleClickFetchAllPermissions()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDisableData = async (idpermiso) => {

        const { FormPermissions, FormPermissionsChild } = Forms
        const { formState: formStateFather, onResetForm: onResetFormFather } = FormPermissions
        const { formState: formStateChild, onResetForm: onResetFormChild } = FormPermissionsChild

        Swal.fire({
            title: '¿Está seguro de Desactivar este registro?',
            text: 'Esta acción hará que el registro sea removido de los listados que se encuentran en todo el sistema y no podrá asociar información a él',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/permissions/disable-permission/${idpermiso}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetFormFather()
                    onResetFormChild()
                    handleClickFetchAllPermissions()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDeleteData = async (idpermiso) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/permissions/delete-permission/${idpermiso}`)
                .then(({ data }) => {
                    console.log(data)
                    handleClickFetchAllPermissions()
                    alertMessage(data)

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }
    
    const onSubmitFormPermissions = async (e, typeSubmit) => {

        e.preventDefault()

        const { FormPermissions, FormPermissionsChild } = Forms
        const { formState: formStateFather, onResetForm: onResetFormFather } = FormPermissions
        const { formState: formStateChild, onResetForm: onResetFormChild } = FormPermissionsChild

        if(typeSubmit === 'PADRE' && formStateFather.nombrepermisos === ''){
            toast.warn("No ha especificado el nombre del permiso", {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
        
        if(typeSubmit === 'HIJO' && FormPermissionsChild.nombrepermisos === ''){
            toast.warn("No ha especificado el nombre del permiso hijo", {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }

        const _dataBody = {
            idpermiso: (typeSubmit === 'PADRE') ? formStateFather.idpermiso : formStateChild.idpermiso,
            idpermiso_padre: (typeSubmit === 'PADRE') ? formStateFather.idpermiso_padre : formStateFather.idpermiso,
            nombrepermisos: (typeSubmit === 'PADRE') ? formStateFather.nombrepermisos : formStateChild.nombrepermisos,
            usuario_creo: user.username,
            fecha_creo: new Date()
        }

        console.log(_dataBody)

        if(_dataBody.idpermiso > 0){

            await marvarApi.put( `/permissions/update-permission/${_dataBody.idpermiso}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    onResetFormFather()
                    onResetFormChild()
                    handleClickFetchAllPermissions()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/permissions/create-permission`, _dataBody )
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetFormFather()
                    onResetFormChild()
                    handleClickFetchAllPermissions()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllPermissions,
        handleClickEnableData,
        handleClickDisableData,
        handleClickDeleteData,
        onSubmitFormPermissions
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}